module.exports = __webpack_public_path__ + "img/paymongo.b1438c85.png";